import angular from 'angular';
import NewProductsComponent from './new-products.component';

let NewProductsModule = angular.module('catalog.newProducts', [])
  .component('newProducts', NewProductsComponent);

export default NewProductsModule;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/new-products/new-products.js
 **/